import api from "src/services/api";

import {
  FiltrosReclamos,
  Reclamo,
  ReclamoProceso,
  RegistroReclamo,
  RegistroReclamoAPI,
} from "src/utils/interfaces";

import {
  estructurarCortes,
  formateoCrearReclamoConHoraProcesada,
  formateoCrearReclamoSinHoraProcesada,
  formateoProcesarReclamo,
} from "src/utils/comunicacionAPI";

import { tiempoTrabajadoEnCortes } from "src/utils/fechas";

export const ReclamosAPI = {
  async verReclamo(id: number) {
    const reclamoFormateado = await api
      .get(`horas/reclamos/detalles/${id}`)
      .then(
        (response) => {
          const reclamo = response.data.datos[0];
          reclamo.fecha = reclamo.fecha_trabajo;

          const cortes = estructurarCortes(reclamo);

          return {
            puntoServicio: {
              nombre: reclamo.ps_nombre,
              codigo: reclamo.ps_codigo,
            },
            nombreOperario: reclamo.op_nombre,
            fecha: new Date(reclamo.fecha_trabajo),
            cortesAprobados: cortes,
            reclamo: reclamo.reclamo,
            estado: reclamo.estado,
          } as Reclamo;
        },
        (error) => error
      );

    return reclamoFormateado;
  },

  async listar(filtros: FiltrosReclamos) {
    const registros: RegistroReclamo[] = [];

    await api.get("horas/reclamos/todos").then(
      (response) => {
        const reclamos = response.data.datos;

        reclamos.forEach((registro: RegistroReclamoAPI) => {
          const cortes = estructurarCortes(registro);

          registros.push({
            id: registro.id,
            codigoPuntoServicio: registro.ps_codigo,
            nombrePuntoServicio: registro.ps_nombre,
            nombreOperario: registro.op_nombre,
            estadoReclamo: registro.estado,
            cortes: cortes,
            fecha: new Date(registro.fecha),
            tiempoTrabajado: tiempoTrabajadoEnCortes(cortes),
            motivo: registro.reclamo,
            estado: registro.estado,
          });
        });
      },
      (error) => error
    );

    return registros;
  },

  async procesarReclamo(id: number, detalles: ReclamoProceso) {
    switch (detalles.accion) {
      case "crear":
        return this.crear(detalles as ReclamoProceso);

      case "cambiar":
        return this.cambiar(id, detalles as ReclamoProceso);

      case "aceptar":
        return this.aceptar(id, detalles as ReclamoProceso);

      default:
        return this.rechazar(id, detalles as ReclamoProceso);
    }
  },

  // crea un reclamo sin usar una hora procesada
  async crear(detalles: ReclamoProceso) {
    const datosReclamo = formateoCrearReclamoSinHoraProcesada(detalles);
    return api.post(`horas/reclamar/nuevo_reclamo`, datosReclamo);
  },

  // crea un reclamo en base a una hora ya procesada
  async cambiar(id: number, detalles: ReclamoProceso) {
    const datosReclamo = formateoCrearReclamoConHoraProcesada(detalles);
    return api.post(`horas/reclamar/${id}`, datosReclamo);
  },

  async aceptar(id: number, detalles: ReclamoProceso) {
    const datosReclamo = formateoProcesarReclamo(detalles);
    return api.post(`horas/reclamos/gestionar/${id}`, datosReclamo);
  },

  async rechazar(id: number, detalles: ReclamoProceso) {
    const datosReclamo = formateoProcesarReclamo(detalles);
    return api.post(`horas/reclamos/gestionar/${id}`, datosReclamo);
  },
};
